import { ReasoningTimeline, reasoningSummary, useElapsed } from '../ReasoningPanel';
import { isVisibleItem } from '../../hooks/messageStream';

/**
 * Visionneuse « Raisonnement » : chronologie complète d'une réponse (réflexion en
 * entier), suivie en direct si la réponse est encore en cours.
 */
export function ReasoningArtifact({ artifact, messages }) {
  const message = messages?.find((m) => m.id === artifact.payload?.messageId);
  const reasoning = message?.reasoning;
  const isRunning = reasoning?.status === 'running';
  const elapsed = useElapsed(reasoning?.startedAt, reasoning?.endedAt, isRunning);

  if (!reasoning) {
    return <p className="artifact-empty">Ce raisonnement n'est plus disponible dans la conversation.</p>;
  }
  const items = reasoning.items.filter(isVisibleItem);

  return (
    <div className="artifact-view artifact-reasoning">
      <p className="artifact-toolbar__meta artifact-reasoning__summary" aria-live="polite">
        {isRunning ? 'Réflexion en cours…' : reasoningSummary(reasoning, elapsed, message.effort)}
      </p>
      {items.length ? (
        <div className="reasoning artifact-reasoning__box">
          <ReasoningTimeline items={items} isRunning={isRunning} full />
        </div>
      ) : (
        <p className="artifact-empty">Aucune étape pour cette réponse.</p>
      )}
    </div>
  );
}
